
var skanGym = skanGym || {};

$(function () {
    skanGym.gallery.init($('.gallery-link'));
});

skanGym.gallery = new function(){
    var self = this;

    this.init = function(selector) {
        // Docs here: http://brutaldesign.github.io/swipebox/
        selector.swipebox({
            loopAtEnd: true
        });

        // Event handler to close swipebox on click outside image
        $('body').on('click', '#swipebox-overlay', function() {
            $.swipebox.close();
        });
    };

};

